import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "@/annotations";
import {
  CreateReviewWidgetConfigRequest,
  PreviewReviewWidgetConfigParams,
  PublicReviewWidget,
  ReviewWidgetConfig,
  UpdateReviewWidgetConfigRequest,
} from "./dtos";

const REVIEW_WIDGET_CONFIG_SERVICE = `${Constants.API_URL}/bedrock/review_widget_configs`;
const PUBLIC_REVIEW_WIDGET_CONFIG_SERVICE = `${Constants.API_URL}/bedrock/public/review_widget_configs`;

export class ReviewWidgetConfigServices {
  @scCatchServiceException()
  static async getConfigs(): Promise<ReviewWidgetConfig[]> {
    const { data } = await axios.get<ReviewWidgetConfig[]>(REVIEW_WIDGET_CONFIG_SERVICE);
    return data;
  }

  @scCatchServiceException()
  static async createConfig(payload: CreateReviewWidgetConfigRequest = {}): Promise<ReviewWidgetConfig> {
    const { data } = await axios.post<ReviewWidgetConfig>(REVIEW_WIDGET_CONFIG_SERVICE, payload);
    return data;
  }

  @scCatchServiceException()
  static async updateConfig(id: number, payload: UpdateReviewWidgetConfigRequest): Promise<ReviewWidgetConfig> {
    const { data } = await axios.patch<ReviewWidgetConfig>(`${REVIEW_WIDGET_CONFIG_SERVICE}/${id}`, payload);
    return data;
  }

  @scCatchServiceException()
  static async getPublicPreview(
    slug: string,
    player: string,
    params: PreviewReviewWidgetConfigParams
  ): Promise<PublicReviewWidget> {
    const { data } = await axios.get<PublicReviewWidget>(`${PUBLIC_REVIEW_WIDGET_CONFIG_SERVICE}/${slug}`, {
      params: { player, ...params, isPreview: true },
    });
    return data;
  }
}
